<template>
<Box @close="close({})" width="800px" v-if="producto">
    <template #top>Registrar Producto</template>
    <template #center>
        <div class="nj-card">
            <div class="nj-grid">
                <InputText label="Producto" v-model="producto.prv_nombre"></InputText>
                <InputSelect v-model="producto.cat_id" id="pn-categorias" :source="categorias" label="Categoria" :labelFunction="labelCategoria" itemKey="id_categoria_producto"
                    itemFilter="descripcion" itemValue="id_categoria_producto" @selectItem="getTiposProducto">
                    <template #default="data">
                        {{ labelCategoria(data.item) }}
                    </template>
                </InputSelect>
                <InputSelect v-model="producto.tip_id" id="pn-tipos_producto" :source="tipos_producto" label="Tipos producto" :labelFunction="labelTipoProducto" itemKey="tip_id" itemValue="tip_id"
                    itemFilter="tip_nombre">
                    <template #default="data">
                        {{ labelTipoProducto(data.item) }}
                    </template>
                </InputSelect>
                <InputSelect v-model="producto.mar_id" id="pn-marcas" :source="marcas" label="Marcas" :labelFunction="labelMarca" itemKey="mar_id" itemValue="mar_id" itemFilter="mar_nombre">
                    <template #default="data">
                        {{ labelMarca(data.item) }}
                    </template>
                </InputSelect>
                <InputSelect v-model="producto.unm_id" id="pn-unidades_medida" :source="unidades_medida" label="Unidad" :labelFunction="labelUnidad" itemKey="unm_id" itemValue="unm_id"
                    itemFilter="unm_descripcion">
                    <template #default="data">
                        {{ labelUnidad(data.item) }}
                    </template>
                </InputSelect>
            </div>
        </div>
    </template>
    <template #bottom>
        <Button icon="save" label="Registrar" @click="registrar()"></Button>
    </template>
</Box>
</template>

<script>
import { ProductoService, ResponseStatus } from "../../rest"
import { Data } from "../../util"
import Toast from "../../util/toast"
import { Button, InputSearch, InputSelect, InputText, Box } from "../components"

export default {
    name: "DuplicarProducto",
    props: {
        prv_id: {
            type: Number,
            default: null
        }
    },
    components: {
        Box,
        InputText,
        InputSearch,
        InputSelect,
        Button,
    },
    data() {
        return {
            categorias: [],
            tipos_producto: [],
            marcas: [],
            unidades_medida: [],
            cat_nombre_text: "",
            tip_nombre_text: "",
            mar_nombre_text: "",
            unm_simbolo_text: "",
            producto: {
                prv_id: null,
                prv_nombre: null,
                prv_estado: null,
                cat_id: null,
                tip_id: null,
                mar_id: null,
                unm_id: null,
            },
            cat_id: null
        }
    },
    computed: {},
    methods: {
        labelCategoria(item) {
            return item.descripcion
        },
        labelTipoProducto(item) {
            return item.tip_nombre
        },
        labelMarca(item) {
            return item.mar_nombre
        },
        labelUnidad(item) {
            return item.unm_descripcion
        },
        getTiposProducto(categoria) {
            this.tipos_producto = categoria
                ? Data.get(Data.listNames.tipos_producto).filter(item => item.cat_id == categoria.id_categoria_producto)
                : []
        },
        registrar() {
            // Para reiniciar el id del producto
            this.producto.prv_id = null
            const request = {
                producto: this.producto,
            }
            ProductoService.registrar(request).then((response) => {
                if (ResponseStatus.isSuccess(response)) {
                    Toast.success(response.message)
                    this.close({
                        renderizar: true
                    })
                } else {
                    Toast.warn(response.message)
                }
            }).catch((error) => {
                Toast.error(error)            })
        },
        close({
            componente = "duplicar",
            activar = false,
            renderizar,
        }) {
            this.$emit("close", {
                componente,
                activar,
                renderizar,
            })
        },
    },
    mounted() {
        const request = {
            producto: {
                prv_id: this.prv_id
            }
        }
        ProductoService.obtener(request).then(response => {
            if (ResponseStatus.isSuccess(response)) {
                this.producto = response.data
                this.categorias = Data.get(Data.listNames.categorias)
                this.marcas = Data.get(Data.listNames.marcas)
                this.unidades_medida = Data.get(Data.listNames.unidades_medida)
            }
            else {
                Toast.warn(response.message)
            }
        }).catch(error => {
            Toast.error(error)        })
    }
}
</script>

<style scoped></style>